import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	padding: 50px 20px;
	color: ${CSSVars.black};

	.posts {
		max-width: 1200px;
		margin: 20px auto 0;

		a {
			background-color: ${CSSVars.white};
			position: relative;
			border: 1px solid ${CSSVars.gray50};
			border-radius: 12px;
			transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
			display: block;

			&:hover {
				transform: translateY(-4px);
				box-shadow: 0 12px 30px rgba(9, 10, 59, 0.08);
				border-color: ${CSSVars.gray100};

				.post .image-wrap img {
					transform: scale(1.04);
				}
			}

			&.first-post-link {
				border: none;
				background: transparent;

				&:hover {
					transform: none;
					box-shadow: none;
				}
			}
		}

		.post {
			border-radius: 12px;
			overflow: hidden;

			&:hover {
				h3 {
					color: ${CSSVars.blue500};
				}
			}

			&.first-post {
				margin-bottom: 50px;
				display: flex;
				align-items: center;
				flex-direction: column;
				gap: 20px;
				padding: 0;

				@media screen and (min-width: ${CSSVars.breakpointLG}) {
					flex-direction: row;
					gap: 50px;
					margin-bottom: 70px;
				}

				.image-wrap {
					position: relative;
					width: 100%;
					max-width: 575px;

					.featured-badge {
						position: absolute;
						top: 16px;
						left: 16px;
						background: linear-gradient(270deg, #ff979c 0%, #4c4fff 100%);
						color: ${CSSVars.white};
						font-size: 11px;
						font-weight: 600;
						letter-spacing: 0.08em;
						text-transform: uppercase;
						padding: 6px 12px;
						border-radius: 999px;
						z-index: 2;
					}
				}

				.details {
					background-color: transparent;

					.cat-tag {
						display: inline-block;
						background: ${CSSVars.blue500};
						color: ${CSSVars.white};
						font-size: 11px;
						font-weight: 600;
						letter-spacing: 0.06em;
						text-transform: uppercase;
						padding: 4px 10px;
						border-radius: 4px;
						margin-bottom: 12px;
					}

					h3 {
						font-size: ${CSSVars.fontSizeXL};
						font-weight: 500;
					}

					.author {
						font-size: ${CSSVars.fontSizeXS};

						@media screen and (min-width: ${CSSVars.breakpointLG}) {
							font-size: ${CSSVars.fontSizeSM};
						}
					}

					.desc {
						font-size: ${CSSVars.fontSizeMD};
						-webkit-line-clamp: 5; /* number of lines to show */
						line-clamp: 5;
						margin-bottom: 20px;

						@media screen and (min-width: ${CSSVars.breakpointLG}) {
							font-size: ${CSSVars.fontSizeLG};
						}
					}

					.read-more {
						font-size: ${CSSVars.fontSizeMD};
						position: static;
					}
				}

				img {
					border-radius: 10px;
					max-width: 575px;
					width: 100%;
					height: 100%;
					max-height: 320px;
					object-fit: cover;
				}
			}

			.image-wrap {
				position: relative;
				overflow: hidden;
				border-radius: 12px 12px 0 0;
				aspect-ratio: 16 / 9;
				background: ${CSSVars.gray50};

				img {
					object-fit: cover;
					width: 100%;
					height: 100%;
					transition: transform 0.4s;
				}

				.cat-tag.floating {
					position: absolute;
					top: 12px;
					left: 12px;
					background: rgba(255, 255, 255, 0.95);
					color: ${CSSVars.blue500};
					font-size: 10px;
					font-weight: 600;
					letter-spacing: 0.06em;
					text-transform: uppercase;
					padding: 5px 10px;
					border-radius: 999px;
					backdrop-filter: blur(4px);
					z-index: 2;
				}
			}

			.details {
				padding: 20px 20px 40px;
				color: ${CSSVars.black};

				h3 {
					transition: 0.2s;
					font-size: ${CSSVars.fontSizeLG};
					font-weight: 500;
				}

				.author {
					font-size: ${CSSVars.fontSizeXS};
					color: ${CSSVars.gray400};
					font-weight: 300;
					margin: 5px 0 10px;
				}

				.desc {
					font-size: ${CSSVars.fontSizeSM};
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 4; /* number of lines to show */
					line-clamp: 4;
					-webkit-box-orient: vertical;
					margin-bottom: 10px;
					font-family: ${CSSVars.secondaryFont};
					line-height: 1.5;
				}

				.read-more {
					color: ${CSSVars.blue500};
					font-size: ${CSSVars.fontSizeSM};
					display: flex;
					align-items: center;
					justify-content: center;
					gap: 10px;
					margin-left: auto;
					transition: 0.2s;
					width: fit-content;
					border: none;
					background-color: transparent;
					cursor: pointer;

					position: absolute;
					bottom: 20px;
					right: 20px;
					font-family: ${CSSVars.primaryFont};
					font-weight: 500;

					&:hover {
						color: ${CSSVars.blue300};
					}
				}
			}
		}

		.posts-container {
			display: grid;
			grid-gap: 24px;
			grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));
		}

		.no-items {
			display: flex;
			align-items: center;
			flex-direction: column;
			gap: 20px;
			margin: 0 auto 100px;
			text-align: center;

			button {
				font-size: 14px;
			}
		}
	}
`;
